import type { SVGProps } from 'react'
const SvgSyEditSolid = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="m13.5 5.5-7.047 7.047c-.225.225-.337.337-.408.476s-.098.296-.15.61l-.78 4.677c-.052.314-.079.472.012.563s.249.064.563.012l4.678-.78c.313-.052.47-.078.61-.15.138-.071.25-.183.475-.408L18.5 10.5c1.017-1.017 1.526-1.526 1.638-2.137.045-.24.045-.486 0-.726-.112-.611-.62-1.12-1.638-2.137s-1.526-1.526-2.137-1.638a2 2 0 0 0-.726 0c-.611.112-1.12.62-2.137 1.638"
		/>
		<path d="m12.293 6.707-5.84 5.84c-.225.225-.337.337-.408.476s-.098.296-.15.61l-.78 4.677c-.052.314-.079.472.012.563s.249.064.563.012l4.678-.78c.313-.052.47-.078.61-.15.138-.071.25-.183.475-.408l5.84-5.84c.333-.333.5-.5.5-.707s-.167-.374-.5-.707l-3.586-3.586c-.333-.333-.5-.5-.707-.5s-.374.167-.707.5" />
	</svg>
)
export default SvgSyEditSolid
